import { render, staticRenderFns } from "./TestCheckout.vue?vue&type=template&id=3519e27b&scoped=true"
import script from "./TestCheckout.vue?vue&type=script&lang=js"
export * from "./TestCheckout.vue?vue&type=script&lang=js"
import style0 from "./TestCheckout.vue?vue&type=style&index=0&id=3519e27b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519e27b",
  null
  
)

export default component.exports